import styled from 'styled-components';

export const FormLabel = styled.label`
    color: rgb(62, 76, 89);
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    letter-spacing: 0em;
    line-height: 1rem;
    font-weight: 400;
`;

export const FormLabelTitle = styled.p`
    color: rgb(62, 76, 89);
    font-weight: 700 !important;
`;